import gql from 'graphql-tag';

import listSettingColumnFragment from './listSettingColumnFragment';

export const listSettingFragment = gql`
  fragment listSettingFragment on ListSetting {
    dokkioClass
    id
    dokkioUserID
    listType
    listKey
    orderByColumn
    orderByDirection
    displayFormat
    density
    galleryScale
    columns {
      ...listSettingColumnFragment
    }
  }
  ${listSettingColumnFragment}
`;
export default listSettingFragment;
